<template>
    <v-row>
        <v-col cols="12">
            <div class="title-label">
                {{ $t('entrance.objective_with_builder') }}
            </div>
            <div class="label">
                {{ $t('entrance.subtext_objective') }}
            </div>
        </v-col>
        <v-col cols="12">
            <kimsa-select
                :items="objectives"
                @change="objectivesArray = $event"
                :values="objectivesArray"
                multiple chip bordered
                ref="obj"
            />
        </v-col>
    </v-row>
</template>

<script>

import KimsaSelect from "../common/inputs/KimsaSelect";
import {mapActions, mapState} from 'vuex'

export default {
    components: {
        KimsaSelect,
    },
    data() {
        return {
            objectivesArray: [],
        }
    },
    computed: {
        ...mapState(['config']),
        objectives(vm = this) {
            if (!vm.config) return []
            return vm.config.objectives.map(objective => ({name: objective, value: objective}))
        }
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        vm.loadObjectives()
    },
    methods: {
        ...mapActions(['bindConfig']),
        loadObjectives() {
            const vm = this
            vm.objectivesArray = vm.account?.objectives || []
        }
    },
    watch: {
        account() {
            this.loadObjectives()
        },
        objectivesArray(val) {
            this.$emit('change', val)
        },
    },
}
</script>

<style scoped>

.title-label {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 30px;
}

.label {
    font-size: 15px;
    color: #707070;
    margin-top: 8px;
    line-height: 20px;
}

</style>